export default "__VITE_ASSET__yW_GQwzX__"